const soundLinks = {
  mainClick: './assets/sounds/butn2.wav',
  cardClick: './assets/sounds/213148__complex-waveform__click.wav',
  nextRoundClick: './assets/sounds/370743__podsburgh__winner-metal-bell-ringing-remix.flac',
  victoryClick: './assets/sounds/466133__humanoide9000__victory-fanfare.wav',
  statisticPopup: './assets/sounds/kamikazerespawn.wav',
  lastTimePopup: './assets/sounds/363867__juanma1008__maquina-tragamonedas.wav',
  mainHover: './assets/sounds/menu1.wav',
};

export default soundLinks;
